/**
 * Swidget Mutation Observer
 *
 * Detect when swidget holders are populated in order to apply
 * classes for loading state and widget type to assist in styling
 */

export default class SwidgetObserver {
  constructor() {
    this.handleMutations = this.handleMutations.bind(this)
    this.observer = new MutationObserver(this.handleMutations)
    this.observeWidgets()
  }

  observeWidgets() {
    const swidgets = document.querySelectorAll('.swidget-holder')
    for (const swidget of swidgets) {
      this.observer.observe(swidget, {
        childList: true,
        subtree: true,
      })
    }
  }

  handleMutations(mutationsList) {
    for (const mutation of mutationsList) {
      // Add swidget type classes to the swidget-holder containers
      if (
        mutation.type === 'childList' &&
        mutation.target.classList.contains('swidget-holder')
      ) {
        // Get the first Element node
        const addedNode = Array.from(mutation.addedNodes).find(
          (el) => el.nodeType === 1
        )

        if (!addedNode) return

        // Get an array of classes of the children
        const childClassnames = Array.from(addedNode.children).reduce(
          (classnames, el) => {
            return [...el.classList, ...classnames]
          },
          []
        )

        // Use the children classes to detect the type of each swidget, and apply class
        if (childClassnames.includes('swidget_tt_item_name')) {
          mutation.target.classList.add('cmoa-swidget-timedtickets')

          // For the timed ticket swidget, we add an actual loading element
          const loadingContainer = document.createElement('div')
          loadingContainer.classList.add('cmoa-swidget-timedtickets-loading')
          loadingContainer.innerHTML = 'Gathering ticket options<span class="ellipses-loader">…</span>'
          mutation.target.appendChild(loadingContainer)
        } else if (childClassnames.includes('swidget_multi_item_name')) {
          mutation.target.classList.add('cmoa-swidget-multicart')
        } else if (
          childClassnames.includes('swidget_item_name') &&
          childClassnames.includes('swidget_tickets')
        ) {
          mutation.target.classList.add('cmoa-swidget-products')
        } else if (childClassnames.includes('swidget_buttons')) {
          mutation.target.classList.add('cmoa-swidget-oneclick')
        }

        // Add loading class
        mutation.target.classList.add('cmoa-swidget-loading')
      }
      // Remove loading classes once the swidget_tickets elements are populated
      else if (
        mutation.type === 'childList' &&
        mutation.target.classList.contains('swidget_tickets')
      ) {
        const parent = mutation.target.closest('.swidget-holder')
        parent.classList.remove('cmoa-swidget-loading')
        parent.classList.add('cmoa-swidget-loaded')
      }
    }
  }
}
